export const environment = {
  production: false,
  apiGatewayUrl: 'https://gatewayapi-dev.restaurante.cieneguillariberadelrio.com',
  promotionsApiUrl: '/api/v1/promotions',
  kitchenApiUrl: '/api/v1/kitchen',
  customersApiUrl: '/api/v1/customers'
};
